import { MetadataDocumentMapping } from '@/utils/mappings';
import { resolveContentBlocks, resolveString } from '@/utils/resolvers';
import { pipe } from 'lodash/fp';
import React, { useRef } from 'react';
import {
  MenuGroupSection,
  MenuItem,
} from '../GlobalHeaderContainer/GlobalHeader/GlobalHeader.interface';
import { menuGroupResolver } from '../GlobalHeaderContainer/resolvers/AccountSectionResolver';
import CMSWrapper from '../shared/CMSWrapper';
import Account from './Account';
import { AccountProps } from './Account.interface';

const AccountMapper = (mapperProps: any) => {
  const {
    content,
    accountMenu: { accountMenu = [] },
    labels = {},
    presentation = {},
  } = mapperProps;

  const accountProps: AccountProps = {
    pageTitle: labels?.pageTitleLabel,
    navigationProps: {
      labels: {
        logoutLabel: labels?.logoutLabel,
      },
      navSections: accountMenu,
    },
    ...content,
  };
  return (
    <div data-datalayer-position="account" data-datalayer-variant={presentation?.datalayerVariant}>
      <Account {...accountProps} />
    </div>
  );
};

const accountMenuMapper = (menuGroup: MenuGroupSection[]) =>
  menuGroup.map((menuGroupSection: MenuGroupSection) => ({
    title: menuGroupSection.primaryNavigationColumnTitle?.displayText,
    links: (menuGroupSection.menuItem as MenuItem[]).map((menuItem) => menuItem.link),
  }));

const AccountCMSWrapper = (brProps: any) => {
  const mapping = useRef({
    'account.labels': 'labels',
    document: [
      'content',
      {
        contentBlocks: ['detailContent', resolveContentBlocks],
        title: ['contentTitle', resolveString],
        pageMetadata: [null, MetadataDocumentMapping],
      },
    ],
    menuaccountDocument: [
      'accountMenu',
      {
        menuGroup: ['accountMenu', pipe(menuGroupResolver, accountMenuMapper)],
      },
    ],
    componentParameterMap: [
      'presentation',
      {
        'variant-label': 'datalayerVariant',
      },
    ],
  });
  const contentButtonNames = useRef({
    document: 'content',
  });

  return (
    <>
      <CMSWrapper
        brProps={brProps}
        render={AccountMapper}
        mapping={mapping.current}
        contentButtonNames={contentButtonNames.current}
      />
    </>
  );
};

export default AccountCMSWrapper;
